var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-data-export',{attrs:{"rows":_vm.processedBookmarks,"columns":_vm.exportColumns,"disabled":_vm.disabled || _vm.bookmarks.length === 0,"filename":("aktivitaeten-urls-" + (_vm.now().format('YYYY-MM-DD-HHmm')))}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }